import { FC } from "react";
import SettingLayout from "../../layout/SettingLayout/SettingLayout";
import AddMemberSection from "../../components/AddMemberSection/AddMemberSection";

const AddMemberView: FC = () => {
    return (
        <SettingLayout title="Add member">
            <AddMemberSection />
        </SettingLayout>
    );
};

export default AddMemberView;
